import type { OwnerStatementSummariesDetailData } from './useOwnerStatementSummariesDetailQuery';

export const getOwnerStatementSummariesDetailLayout = ({
  data,
  layoutId,
}: {
  data: Pick<OwnerStatementSummariesDetailData, 'layouts'>;
  layoutId: string;
}) => {
  const layout = data.layouts.find((item) => item.layoutId === layoutId);

  if (!layout) {
    throw new Error(`Missing owner statement summary layout: ${layoutId}`);
  }

  return layout;
};
